// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* BUTTON COMPONENT STYLES - VANTA INSPIRED     */
/* ============================================= */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border-radius: 0.625rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  position: relative;
  overflow: hidden;
}

/* Button Sizes */
.btn-sm {
  padding: 0.375rem 0.875rem;
  font-size: 0.75rem;
}

.btn-md {
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
}

.btn-lg {
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
}

.btn-xl {
  padding: 1rem 1.75rem;
  font-size: 1.125rem;
}

/* Button Variants - Primary */
.btn-primary {
  background-color: var(--app-primary-color, #26256b);
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.15);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--app-primary-color, #26256b);
  filter: brightness(0.9);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  filter: brightness(0.85);
  transform: translateY(0);
}

/* Dark mode — same gradient as active sidebar menu item */
.dark .btn-primary {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--app-primary-color, #26256b), white 30%) 0%,
    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 50%) 60%,
    color-mix(in srgb, var(--app-primary-color, #26256b), white 12%) 100%
  );
  box-shadow:
    0 2px 14px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),
    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent);
}

.dark .btn-primary:hover:not(:disabled) {
  filter: brightness(1.15);
  box-shadow:
    0 4px 20px color-mix(in srgb, var(--app-primary-color, #26256b) 55%, transparent),
    0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 35%, transparent);
  transform: translateY(-1px);
}

/* Button Variants - Secondary */
.btn-secondary {
  background-color: #F1F5F9;
  color: #0F172A;
  border: 1px solid #E2E8F0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-secondary:hover:not(:disabled) {
  background-color: #E2E8F0;
  border-color: #CBD5E1;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.dark .btn-secondary {
  background-color: #334155;
  color: #F8FAFC;
  border-color: #475569;
}

.dark .btn-secondary:hover:not(:disabled) {
  background-color: #475569;
  border-color: #64748B;
}

/* Button Variants - Outline */
.btn-outline {
  background-color: transparent;
  color: var(--app-primary-color, #26256b);
  border: 2px solid var(--app-primary-color, #26256b);
}

.btn-outline:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 8%, white);
  border-color: var(--app-primary-color, #26256b);
  filter: brightness(0.95);
}

/* Dark mode outline */
.dark .btn-outline {
  color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);
  border-color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);
}

.dark .btn-outline:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 20%, transparent);
}

/* Button Variants - Ghost */
.btn-ghost {
  background-color: transparent;
  color: var(--app-primary-color, #26256b);
}

.btn-ghost:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 8%, white);
  filter: brightness(0.95);
}

/* Dark mode ghost */
.dark .btn-ghost {
  color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);
}

.dark .btn-ghost:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 20%, transparent);
}

/* Button Variants - Danger */
.btn-danger {
  background-color: #EF4444;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.15);
}

.btn-danger:hover:not(:disabled) {
  background-color: #DC2626;
  box-shadow: 0 10px 15px -3px rgba(239, 68, 68, 0.25);
  transform: translateY(-1px);
}

/* Button Variants - Success */
.btn-success {
  background-color: #22C55E;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(34, 197, 94, 0.15);
}

.btn-success:hover:not(:disabled) {
  background-color: #16A34A;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.25);
  transform: translateY(-1px);
}

/* Button Variants - Warning */
.btn-warning {
  background-color: #F59E0B;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(245, 158, 11, 0.15);
}

.btn-warning:hover:not(:disabled) {
  background-color: #D97706;
  box-shadow: 0 10px 15px -3px rgba(245, 158, 11, 0.25);
  transform: translateY(-1px);
}

/* Button States */
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-full-width {
  width: 100%;
}

/* Button Icon */
.btn-icon {
  width: 1.25em;
  height: 1.25em;
  flex-shrink: 0;
}

/* Button Loading Spinner */
.btn-loading-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Button.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,mDAAmD;EACnD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;EACvB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE;;;;;GAKC;EACD;;oFAEkF;AACpF;;AAEA;EACE,wBAAwB;EACxB;;oFAEkF;EAClF,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,iFAAiF;EACjF,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,uEAAuE;EACvE,8EAA8E;AAChF;;AAEA;EACE,wFAAwF;AAC1F;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,iFAAiF;EACjF,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,uEAAuE;AACzE;;AAEA;EACE,wFAAwF;AAC1F;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ============================================= */\n/* BUTTON COMPONENT STYLES - VANTA INSPIRED     */\n/* ============================================= */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1rem;\n  border-radius: 0.625rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Button Sizes */\n.btn-sm {\n  padding: 0.375rem 0.875rem;\n  font-size: 0.75rem;\n}\n\n.btn-md {\n  padding: 0.625rem 1rem;\n  font-size: 0.875rem;\n}\n\n.btn-lg {\n  padding: 0.875rem 1.5rem;\n  font-size: 1rem;\n}\n\n.btn-xl {\n  padding: 1rem 1.75rem;\n  font-size: 1.125rem;\n}\n\n/* Button Variants - Primary */\n.btn-primary {\n  background-color: var(--app-primary-color, #26256b);\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.15);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--app-primary-color, #26256b);\n  filter: brightness(0.9);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);\n  transform: translateY(-1px);\n}\n\n.btn-primary:active:not(:disabled) {\n  filter: brightness(0.85);\n  transform: translateY(0);\n}\n\n/* Dark mode — same gradient as active sidebar menu item */\n.dark .btn-primary {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--app-primary-color, #26256b), white 30%) 0%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 50%) 60%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), white 12%) 100%\n  );\n  box-shadow:\n    0 2px 14px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),\n    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent);\n}\n\n.dark .btn-primary:hover:not(:disabled) {\n  filter: brightness(1.15);\n  box-shadow:\n    0 4px 20px color-mix(in srgb, var(--app-primary-color, #26256b) 55%, transparent),\n    0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 35%, transparent);\n  transform: translateY(-1px);\n}\n\n/* Button Variants - Secondary */\n.btn-secondary {\n  background-color: #F1F5F9;\n  color: #0F172A;\n  border: 1px solid #E2E8F0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #E2E8F0;\n  border-color: #CBD5E1;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.dark .btn-secondary {\n  background-color: #334155;\n  color: #F8FAFC;\n  border-color: #475569;\n}\n\n.dark .btn-secondary:hover:not(:disabled) {\n  background-color: #475569;\n  border-color: #64748B;\n}\n\n/* Button Variants - Outline */\n.btn-outline {\n  background-color: transparent;\n  color: var(--app-primary-color, #26256b);\n  border: 2px solid var(--app-primary-color, #26256b);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 8%, white);\n  border-color: var(--app-primary-color, #26256b);\n  filter: brightness(0.95);\n}\n\n/* Dark mode outline */\n.dark .btn-outline {\n  color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);\n  border-color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);\n}\n\n.dark .btn-outline:hover:not(:disabled) {\n  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 20%, transparent);\n}\n\n/* Button Variants - Ghost */\n.btn-ghost {\n  background-color: transparent;\n  color: var(--app-primary-color, #26256b);\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 8%, white);\n  filter: brightness(0.95);\n}\n\n/* Dark mode ghost */\n.dark .btn-ghost {\n  color: color-mix(in srgb, var(--app-primary-color, #26256b), white 40%);\n}\n\n.dark .btn-ghost:hover:not(:disabled) {\n  background-color: color-mix(in srgb, var(--app-primary-color, #26256b) 20%, transparent);\n}\n\n/* Button Variants - Danger */\n.btn-danger {\n  background-color: #EF4444;\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.15);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #DC2626;\n  box-shadow: 0 10px 15px -3px rgba(239, 68, 68, 0.25);\n  transform: translateY(-1px);\n}\n\n/* Button Variants - Success */\n.btn-success {\n  background-color: #22C55E;\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(34, 197, 94, 0.15);\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: #16A34A;\n  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.25);\n  transform: translateY(-1px);\n}\n\n/* Button Variants - Warning */\n.btn-warning {\n  background-color: #F59E0B;\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(245, 158, 11, 0.15);\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: #D97706;\n  box-shadow: 0 10px 15px -3px rgba(245, 158, 11, 0.25);\n  transform: translateY(-1px);\n}\n\n/* Button States */\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-full-width {\n  width: 100%;\n}\n\n/* Button Icon */\n.btn-icon {\n  width: 1.25em;\n  height: 1.25em;\n  flex-shrink: 0;\n}\n\n/* Button Loading Spinner */\n.btn-loading-spinner {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
